"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SenderSelect/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);

var _Tooltip = require('web/components/Tooltip');
var _Avatar = require('web/components/Avatar');
var _Section = require('./Section'); var _Section2 = _interopRequireDefault(_Section);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

const tooltipOffset = { top: 5 }













const SenderSelect = ({
  myOrgEntitiesList = [],
  myTeamEntitiesList = [],
  senderEntity,
  onSelectSenderKey,
  entityClassName,
  shouldShowEntityDesc,
  shouldShowSectionLabels = true,
  renderBlankState = false,
  avatarSize,
}) => {
  const { isOpen, onOpen, onClose } = _useToggle2.default.call(void 0, )

  // Escape closes an open menu and goes no further, so a dialog around it
  // (New chat, which steps back on Escape's keyup) stays where it is.
  _react.useEffect.call(void 0, () => {
    if (!isOpen) return
    const onKeyUp = (e) => {
      if (e.key !== 'Escape') return
      e.stopPropagation()
      onClose()
    }
    window.addEventListener('keyup', onKeyUp, true)
    return () => window.removeEventListener('keyup', onKeyUp, true)
  }, [isOpen, onClose])
  const onTriggerKeyDown = _react.useCallback.call(void 0, (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return
    e.preventDefault()
    onOpen()
  }, [onOpen])

  const handleSelectSenderKey = _react.useCallback.call(void 0, 
    (senderKey) => {
      onSelectSenderKey(senderKey)
      onClose()
    },
    [onSelectSenderKey, onClose],
  )

  if (!senderEntity && !renderBlankState) return null

  const content = (
    _react2.default.createElement(_Tooltip.TooltipContent, { className: "sender-select--tooltip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
      , _react2.default.createElement(_Section2.default, {
        label: shouldShowSectionLabels ? "Participate as..." : null,
        optionEntities: myOrgEntitiesList,
        selectedOptionKey: _optionalChain([senderEntity, 'optionalAccess', _ => _.entityKey]),
        onSelectOption: handleSelectSenderKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
      )
      ,  myOrgEntitiesList.length && myTeamEntitiesList.length
        ? _react2.default.createElement('div', { className: "sender-select--tooltip--divider", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}} )
        : null
      
      , _react2.default.createElement(_Section2.default, {
        label: shouldShowSectionLabels ? "Participate on behalf of..." : null,
        optionEntities: myTeamEntitiesList,
        selectedOptionKey: _optionalChain([senderEntity, 'optionalAccess', _2 => _2.entityKey]),
        onSelectOption: handleSelectSenderKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
      )
    )
  )

  return (
    _react2.default.createElement(_Tooltip.ControlledTooltip, {
      isOpen: isOpen,
      fullContentWidth: true,
      hideArrow: true,
      offset: tooltipOffset,
      place: "bottom-left",
      onClose: onClose,
      content: content, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}

      , _react2.default.createElement('div', {
        role: "button",
        tabIndex: 0,
        'aria-haspopup': "listbox",
        'aria-expanded': isOpen,
        onClick: onOpen,
        onKeyDown: onTriggerKeyDown,
        className: _classBuilder2.default.call(void 0, 
          "sender-select--entity",
          entityClassName,
          isOpen && 'sender-select--entity--open',
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}

        ,  senderEntity && (
          _react2.default.createElement(_Avatar.EntityAvatar, {
            entity: senderEntity,
            className: "sender-select--entity--avatar",
            size: _nullishCoalesce(avatarSize, () => ( (shouldShowEntityDesc ? 36 : 28))), __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
          )
        )
        , _react2.default.createElement('div', { className: "sender-select--entity--info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}
          , _react2.default.createElement('span', { className: "sender-select--entity--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}
            ,  _optionalChain([senderEntity, 'optionalAccess', _3 => _3.name]) || 'Choose a team…' 
          )
          ,  shouldShowEntityDesc && senderEntity && (
            _react2.default.createElement('span', { className: "sender-select--entity--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}
              ,  senderEntity.description 
            )
          )
        )
        , _react2.default.createElement('div', { className: "sender-select--entity--toggle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}} )
      )
    )
  )
}

exports. default = SenderSelect
